<template>
  <icon-svg v-if="text"
            v-b-tooltip.hover
            icon="helpCircle"
            class="icon--sm ml-1"
            style="fill: #074f7f !important;"
            :title="text" />
</template>

<script>
  export default {
    name: "Interrogacao",
    props: {
      text: {
        type: String
      }
    },
    data () {
      return {}
    },
  }
</script>

<style lang="scss">
</style>
